const STEPS = [
  {
    tag: "STEP 01",
    title: "現象を、そのまま見る",
    desc: "先入観を持たず、現象・条件・工程・データを一次情報として確認します。何が起きているのかを、まず正確に捉えます。",
    icon: "ri-eye-line",
  },
  {
    tag: "STEP 02",
    title: "仮説を、複数立てる",
    desc: "材料・工程・環境・人・設備など複数の観点から要因候補を整理します。特定の要因に早期に決めつけず、複数の仮説を並行して検討します。",
    icon: "ri-bubble-chart-line",
  },
  {
    tag: "STEP 03",
    title: "分けて、検証する",
    desc: "仮説ごとに検証条件を設計し、影響因子を切り分けます。可能な限り定量的に比較し、原因候補を絞り込みます。",
    icon: "ri-flask-line",
  },
  {
    tag: "STEP 04",
    title: "再発しない形に、直す",
    desc: "原因が特定できたら、工程・条件・治工具・評価方法などを見直し、同じ問題が再発しにくい状態を設計します。",
    icon: "ri-shield-check-line",
  },
];

export default function Approach() {
  return (
    <section id="approach" className="relative w-full py-24 md:py-32 bg-background-200/60 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "url('/images/approach.svg')",
          backgroundSize: "cover",
        }}
      />
      <div className="relative w-full max-w-6xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-[1px] bg-primary-500" />
              <span className="text-[11px] tracking-[0.35em] text-primary-500 uppercase">Approach</span>
            </div>
            <h4 className="font-heading text-3xl md:text-4xl text-foreground-900 leading-snug">
              <a href="#approach" className="cursor-pointer">原因究明への<br />アプローチ</a>
            </h4>
          </div>
          <div className="lg:col-span-7 flex items-center">
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
              経験則や勘だけに頼らず、
              現象の観察、仮説の設定、検証を繰り返しながら原因を絞り込みます。
              特定の要因に早期に決めつけず、複数の可能性を比較しながら進めます。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {STEPS.map((s) => (
            <div
              key={s.tag}
              className="bg-background-50 border border-background-200 rounded-lg p-7 md:p-8 flex gap-5 hover:border-accent-300 transition-colors"
            >
              <div className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className={`${s.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <div className="text-[11px] tracking-[0.25em] text-accent-500 mb-2">{s.tag}</div>
                <h5 className="font-heading text-lg text-foreground-900 mb-2">{s.title}</h5>
                <p className="text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}